import {Directive, HostListener} from '@angular/core';
import {NgModel} from '@angular/forms';

@Directive({
  selector: '[wsdExportRangeValues]'
})
export class ExportRangeValuesDirective {

  constructor(private ngModel: NgModel) {
  }

  @HostListener('focus') onFocus() {
    if (!this.ngModel.model) {
      this.ngModel.update.emit(new Date().getFullYear());
    }
  }

  @HostListener('blur') onBlur() {
    if (this.ngModel.model < 1907 || this.ngModel.model > new Date().getFullYear()) {
      this.ngModel.update.emit(new Date().getFullYear());
    }
  }
}
